export enum CustomerAttachmentCategory {
    CustomerOrder = 0,
}